import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import pMinDelay from 'p-min-delay';
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from '@mui/styles';

export default function TestimonialSlider(props) {
  const TestimonialCarousel = loadable(
    () =>
      pMinDelay(
        import('./TestimonialCarousel/index'),
        300 + (props.delay || 0),
      ),
    {
      fallback: (
        <div className="my-14">
          <LoadingSkeleton></LoadingSkeleton>
        </div>
      ),
    },
  );

  return (
    <FadeInWhenVisible
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
    >
      <TestimonialCarousel {...props}></TestimonialCarousel>
    </FadeInWhenVisible>
  );
}

function FadeInWhenVisible(props) {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const [hasComeInViewOnce, setHasComeInViewOnce] = useState(false);

  useEffect(() => {
    if (inView) {
      controls.start('visible');
      setHasComeInViewOnce(true);
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: props.duration ? props.duration : 0.8 }}
      {...props}
      //   exit="hidden"
    >
      {hasComeInViewOnce ? props.children : <Placeholder></Placeholder>}
    </motion.div>
  );
}

function Placeholder() {
  return <div className="h-[175px]"></div>;
}

function LoadingSkeleton() {
  const classes = useStyles();

  return (
    <div className=" flex h-full  w-full justify-center gap-x-10 overflow-hidden ">
      {Array(3)
        .fill()
        .map((ele, idx) => (
          <div key={idx} className={`${classes.avatarSkeletonContainer} `}>
            <Skeleton className={classes.avatarLoader} animation="wave" />
          </div>
        ))}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  avatarSkeletonContainer: {
    height: 0,
    overflow: 'hidden',
    position: 'relative',
    minWidth: '300px ',
    borderRadius: '30px',
    height: '245px',
  },
  avatarLoader: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100% !important',
    transform: 'scale(1) !important',
  },
}));
